import styled from "styled-components";

// Styles
export const MainDiv = styled.div`
  margin: auto;
  padding: 16px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
  gap: 8px;
`;
export const NotesTitle = styled.p`
  margin-bottom: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const NoNotesDiv = styled.div`
  margin: 10px auto 0;
  padding: 16px;
  width: 100%;
  background-color: rgba(242, 242, 242, 0.95);
  border-radius: 5px;
`;
export const NoNotesText = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #808080;
`;
export const NotesDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
export const NoteDate = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;
export const NoteBox = styled.div`
  padding: 10px;
  width: 85%;
  background-color: rgba(242, 242, 242, 0.95);
  border-radius: 5px;
  color: #808080;
  font-size: 14px;
  font-weight: 400;
`;
export const OpenPopupButton = styled.button`
  height: fit-content;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
`;
export const OpenPopupImg = styled.img`
  width: 24px;
  height: 24px;
`;
export const ActionsDiv = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
export const NewNoteButton = styled.button`
  padding: 8px 16px;
  width: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background: #26a9b6;
  box-shadow: 0px 1px 0px 0px #1c7983;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
